export default {
    dependencies: ['$element', 'geoservice', 'trackingservice'],
    callable(link, geoservice, trackingService) {
        const GEO_TIMEOUT = 5000;

        link.addEventListener('click', onLinkClicked);

        function onLinkClicked(evt) {
            if (
                event.button !== 0 ||
                event.metaKey ||
                event.shiftKey ||
                event.ctrlKey ||
                event.altKey
            ) {
                return;
            }

            evt.preventDefault();

            trackingService.trackLaterObj({
                ecType: 'SEARCH',
                ecCategory: 'BrowsepageQuickLinkGeoClick',
            });

            geoservice
                .getCurrentPosition({ timeout: GEO_TIMEOUT })
                .then(onGeoLocation)
                .catch(onError);
        }

        function onError() {
            window.location = link.href;
        }

        function onGeoLocation(coords) {
            const url = new URL(link.href);
            url.searchParams.set('lat', coords.latitude);
            url.searchParams.set('lon', coords.longitude);
            window.location = url.href;
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/searchQuickLinkGeo.js